/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowasktext3Inputs */

const en_aiflowasktext3 = /** @type {(inputs: Aiflowasktext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title and date right on the image?`)
};

const de_aiflowasktext3 = /** @type {(inputs: Aiflowasktext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel und Datum direkt aufs Bild?`)
};

/**
* | output |
* | --- |
* | "Title and date right on the image?" |
*
* @param {Aiflowasktext3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowasktext3 = /** @type {((inputs?: Aiflowasktext3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowasktext3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowasktext3(inputs)
	return de_aiflowasktext3(inputs)
});
export { aiflowasktext3 as "aiFlowAskText" }